import { EmptyComponent } from "./EmptyComponent.js";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import DefaultImage from "../../styles/svgs/default-icon.svg";

const Img = props => {
  const {
    iconName,
    children = null,
    alt,
    link,
    hasLoadingIcon,
    ...restProps
  } = props;
  const [path, setPath] = useState(null);

  useEffect(() => {
    const setSvgPath = async () => {
      try {
        const module = await import(`../../styles/svgs/${iconName}.svg`);
        setPath(module.default);
      } catch (error) {
        console.error(`Failed to load SVG: ${iconName}`, error);
      }
    };

    if (iconName) {
      setSvgPath();
    }
  }, [iconName]);

  const imagePath = useMemo(() => {
    if (path) {
      return path;
    } else if (hasLoadingIcon) {
      return DefaultImage;
    }
  }, [hasLoadingIcon, path]);

  if (!iconName) return <EmptyComponent />;

  return imagePath ? (
    <>
      {link ? (
        <a
          href={link.href}
          data-category={link.dataCategory}
          data-action={link.dataAction}
          data-label={link.dataLabel}
          data-value={link.value}
          className={link.className}
        >
          <img src={path} alt={alt} {...restProps} />
          {children && <>{children}</>}
        </a>
      ) : (
        <>
          <img src={path} alt={alt} {...restProps} />
          {children && <>{children}</>}
        </>
      )}
    </>
  ) : (
    <EmptyComponent />
  );
};

Img.propTypes = {
  iconName: PropTypes.string,
  alt: PropTypes.string,
  LoadingIcon: PropTypes.func,
  children: PropTypes.any,
  link: PropTypes.any,
  hasLoadingIcon: PropTypes.bool
};

export const ImgComponent = React.memo(Img);
